import { supabase } from "@/lovable-demo/runtime/client";
import { permissionsForRoles, type AppRole, type Permission } from "./types";

/** Roles live in their own table and are never read from the profile. */
export async function fetchMyRoles(): Promise<AppRole[]> {
  const { data: userData } = await supabase.auth.getUser();
  const uid = userData.user?.id;
  if (!uid) return [];
  const { data } = await supabase.from("user_roles").select("role").eq("user_id", uid);
  const roles = (data ?? []).map((r) => r.role as AppRole);
  return roles;
}

export async function fetchMyPermissions(): Promise<Permission[]> {
  return permissionsForRoles(await fetchMyRoles());
}
